<template>
  <Transition name="fade-fast">
    <main v-if="$page" class="content privacy">
      <h2 class="privacy__title">{{ $page.title }}</h2>
      <RawHtml class="privacy__desc" :html="$page.description"></RawHtml>
    </main>
  </Transition>
  <Transition name="fade-fast">
    <Loader v-if="!$page || !$beet.isReady" />
  </Transition>
</template>

<script>
import RawHtml from '@/components/global/RawHtml.vue'
import Loader from '@/components/Loader.vue'
import PageMetaMixin from '@/mixins/PageMetaMixin.js'

export default {
  name: 'Privacy',
  components: { Loader, RawHtml },
  beetPage: 'privacy',
  mixins: [PageMetaMixin],
}
</script>
